"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
var _lodash = require("lodash");
var _icon = _interopRequireDefault(require("@evidation/icon"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var ActionContainer = _styledComponents["default"].div.withConfig({
  displayName: "ActionCellSpan__ActionContainer"
})(["cursor:pointer;float:left;height:20px;margin:auto 5px;"]);
var renderAction = function renderAction(action) {
  if (action.icon) {
    return /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      name: action.icon,
      size: "20",
      color: "blue",
      title: action.name
    });
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, action.name);
};
var ActionCellSpan = function ActionCellSpan(props) {
  var className = 'cell-left';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, props.actions.map(function (action, index) {
    return /*#__PURE__*/_react["default"].createElement(ActionContainer, {
      key: "".concat(props.row.rowIndex, "-").concat(index),
      onClick: function onClick(e) {
        e.stopPropagation();
        action.action(props.row);
      }
    }, renderAction(action));
  }));
};
var _default = exports["default"] = ActionCellSpan;